
import Vue from 'vue';
import Component from 'vue-class-component';

import { getModule } from 'vuex-module-decorators';
import Auth from '@/store/modules/auth';
import store from '@/store/store';
import { db } from '@/plugins/firebase';
import firebase from '@/plugins/firebase';
import { Watch } from 'vue-property-decorator';

const authModule = getModule(Auth, store);

@Component
export default class Questionnaire extends Vue {
  email = '';
  sent = false;
  error = false;
  unknownError = false;
  registrationNum = 0;

  get currentUser() {
    return authModule.currentUser;
  }

  get isEmailValid() {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email);
  }

  @Watch('currentUser', { immediate: true })
  async getRegistrationNum() {
    if (!this.currentUser) return;
    const uid = this.currentUser.uid;
    const ref = db.collection('QuestionnaireEntries').where('uid', '==', uid);
    const docs = await ref.get();
    if (docs.size > 0) {
      console.log('request found:', docs.docs[0].data());
      this.registrationNum = docs.docs[0].data().registrationNum;
    } else {
      const allRef = db.collection('QuestionnaireEntries');
      const all = await allRef.get();
      console.log(all);
      this.registrationNum = all.size + 1010;
      await db.collection('QuestionnaireEntries').add({
        uid,
        registrationNum: this.registrationNum,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      });
    }
  }

  async register() {
    this.sent = false;
    this.error = false;
    this.unknownError = false;
    console.log(this.email);
    if (!this.isEmailValid) {
      return (this.error = true);
    } else {
      this.error = false;
    }
    if (this.currentUser) {
      const uid = this.currentUser.uid;
      const ref = db.collection('QuestionnaireEntries').doc(uid);
      const data = {
        uid,
        email: this.email,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      };
      try {
        await ref.set(data);
      } catch (err) {
        return (this.unknownError = true);
      }

      this.sent = true;
    }
  }
}
